/**
 * Token migration utility to help existing users transition from localStorage to cookies
 */
import { setRefreshToken, getRefreshToken } from './cookieUtils';

/**
 * Migrate refresh token from localStorage to secure cookie
 * This should be called on app initialization to ensure smooth transition
 */
export const migrateRefreshTokenFromLocalStorage = () => {
  try {
    // Check if we already have the token in cookie
    const existingCookieToken = getRefreshToken();
    
    // If we already have a token in cookie, no migration needed
    if (existingCookieToken) {
      // Clean up any old localStorage token
      const oldToken = localStorage.getItem('refresh_token');
      if (oldToken) {
        localStorage.removeItem('refresh_token');
        console.log('✅ Cleaned up old refresh token from localStorage');
      }
      return;
    }

    // Check for existing token in localStorage
    const localStorageToken = localStorage.getItem('refresh_token');
    
    if (localStorageToken) {
      // Migrate token to secure cookie
      setRefreshToken(localStorageToken);
      
      // Remove from localStorage
      localStorage.removeItem('refresh_token');
      
      console.log('✅ Successfully migrated refresh token from localStorage to secure cookie');
    }
  } catch (error) {
    console.warn('⚠️ Failed to migrate refresh token:', error);
  }
};

/**
 * Check and migrate tokens on app startup
 * Call this function early in your app initialization
 */
export const performTokenMigration = () => {
  migrateRefreshTokenFromLocalStorage();
}; 